import { useLocale, useT } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi, type PlatformModule } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

const CLUSTERS: Array<{ key: string; label: string }> = [
  { key: 'core', label: 'Platform core' },
  { key: 'command_monitoring', label: 'Command & monitoring' },
  { key: 'trust_compliance', label: 'Trust & compliance' },
  { key: 'operating', label: 'Operating modules' },
  { key: 'assessment_engine', label: 'Assessment engine' },
];

export default function Platform() {
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.platformModules(locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('nav.platform')}</span>
          <h1>CYRKIL Intelligence Platform</h1>
          <p className="body-lg">Layers: Data → Models → Agents → Automation → Governance → Security → Analytics → Business Applications.</p>
        </div>
        <AsyncSection
          state={state}
          render={(modules) => (
            <>
              {CLUSTERS.map((cluster) => {
                const items = modules.filter((m: PlatformModule) => m.cluster === cluster.key);
                if (items.length === 0) return null;
                return (
                  <div key={cluster.key} style={{ marginTop: 48 }}>
                    <h2>{cluster.label}</h2>
                    <div className="card-grid">
                      {items.map((m) => (
                        <div className="card reveal is-visible" key={m.code}>
                          <span className={`badge badge-${m.classification.toLowerCase()}`}>{m.classification}</span>
                          <h3 style={{ marginTop: 12 }}>{m.name}</h3>
                          <p className="body-sm">{m.description}</p>
                          {!m.demoAvailable && <p className="body-sm" style={{ opacity: 0.6 }}>No live demo yet</p>}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        />
      </div>
    </section>
  );
}
